var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarFullPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 9.96 9.67)",
    id: "TkdUGsd6JzzDj4VrWeuFr"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(107,70,236)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-9.96, -9.67)",
    d: "M 9.00822 3.69098 C 9.30757 2.76967 10.611 2.76967 10.9103 3.69098 L 11.8676 6.63729 C 12.0015 7.04931 12.3855 7.32827 12.8187 7.32827 L 15.9166 7.32827 C 16.8854 7.32827 17.2881 8.56789 16.5044 9.13729 L 13.9981 10.9582 C 13.6476 11.2128 13.501 11.6642 13.6349 12.0762 L 14.5922 15.0225 C 14.8915 15.9439 13.837 16.71 13.0533 16.1406 L 10.5471 14.3197 C 10.1966 14.065 9.72197 14.065 9.37149 14.3197 L 6.86521 16.1406 C 6.08149 16.71 5.02702 15.9439 5.32637 15.0225 L 6.28368 12.0762 C 6.41756 11.6642 6.2709 11.2128 5.92041 10.9582 L 3.41413 9.13729 C 2.63042 8.56789 3.0332 7.32827 4.00192 7.32827 L 7.09985 7.32827 C 7.53307 7.32827 7.91703 7.04931 8.0509 6.63729 L 9.00822 3.69098 Z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFullPurple);
export default __webpack_public_path__ + "static/media/star-full_purple.0d0a11575cbee4cf8fdc731520357801.svg";
export { ForwardRef as ReactComponent };